module.exports = __webpack_public_path__ + "img/2023-09.ac7ff2f2.jpg";